interface EnvConfig {
    apiUrl: string
    authUrl: string
    authAPIUrl: string
    pdfUrl: string
    geocodingApiKey: string
    frontendUriBase: string
    hazGuideQuickUriBase: string
}

const ENV: { [key: string]: EnvConfig } = {
    dev: {
        apiUrl: 'https://localho.st:5556',
        authUrl: 'https://localho.st:4455',
        authAPIUrl: 'https://localho.st:4000',
        pdfUrl: 'https://atlas.hazadaptlabs.xyz',
        geocodingApiKey:
            'pk.eyJ1IjoiaGF6YWRhcHQiLCJhIjoiY2w5N3NpMTFiMzE4YzNubm55Mzkya3k0dCJ9.pV4QLtu5laybnMgQxv4y1Q',
        frontendUriBase: 'https://localho.st',
        hazGuideQuickUriBase: 'https://localho.st:3001',
    },
    staging: {
        apiUrl: 'https://triton.hazadaptlabs.xyz',
        authUrl: 'https://oberon.hazadaptlabs.xyz',
        authAPIUrl: 'https://auth.hazadaptlabs.xyz',
        pdfUrl: 'https://atlas.hazadaptlabs.xyz',
        geocodingApiKey:
            'pk.eyJ1IjoiaGF6YWRhcHQiLCJhIjoiY2w5N3NpMTFiMzE4YzNubm55Mzkya3k0dCJ9.pV4QLtu5laybnMgQxv4y1Q',
        frontendUriBase: 'https://earth.hazadaptlabs.xyz',
        hazGuideQuickUriBase: 'https://moon.hazadaptlabs.xyz',
    },
    beta: {
        apiUrl: 'https://api.hazadapt.com',
        authUrl: 'https://id.hazadapt.com',
        authAPIUrl: 'https://iam.hazadapt.com',
        pdfUrl: 'https://cdn.hazadapt.com',
        geocodingApiKey:
            'pk.eyJ1IjoiaGF6YWRhcHQiLCJhIjoiY2xtZWc1bzJ1MTk4ZDNzcDg5NXFxemh1bCJ9.tIeWOHmFoMnCK_RoxIR_Qw',
        frontendUriBase: 'https://public-haz-web-vbeta-2023.hazadapt.com',
        hazGuideQuickUriBase: 'https://haz.guide',
    },
    prod: {
        apiUrl: 'https://api.hazadapt.com',
        authUrl: 'https://id.hazadapt.com',
        authAPIUrl: 'https://iam.hazadapt.com',
        pdfUrl: 'https://cdn.hazadapt.com',
        geocodingApiKey:
            'pk.eyJ1IjoiaGF6YWRhcHQiLCJhIjoiY2xtZWc1bzJ1MTk4ZDNzcDg5NXFxemh1bCJ9.tIeWOHmFoMnCK_RoxIR_Qw',
        frontendUriBase: 'https://app.hazadapt.com',
        hazGuideQuickUriBase: 'https://haz.guide',
    },
    error: {
        apiUrl: '',
        authUrl: '',
        authAPIUrl: '',
        pdfUrl: '',
        geocodingApiKey: '',
        frontendUriBase: '',
        hazGuideQuickUriBase: '',
    },
}

export const getEnvVars = (
    env: string | undefined = process.env.REACT_APP_DEPLOY_ENV
) => {
    if (env === 'dev') {
        return ENV.dev
    } else if (env === 'staging') {
        return ENV.staging
    } else if (env === 'beta') {
        return ENV.beta
    } else if (env === 'production') {
        return ENV.prod
    } else {
        return ENV.error
    }
}

export const inDevEnv = () =>
    process.env.REACT_APP_DEPLOY_ENV === 'dev' ||
    process.env.REACT_APP_DEPLOY_ENV === 'staging'
export const inBetaEnv = () => process.env.REACT_APP_DEPLOY_ENV === 'beta'
